import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import { images } from "../shared/images";
// import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import Terms from "../components/Terms";
const Home = () => {
	const [openTerms, setOpenTerms] = useState(false);
	const [copyValue, setcopyValue] = useState(
		"0x691f0d81190085526EA1b7c631B5a9028aeaEcF7"
	);
	const [copyMessage, setcopyMessage] = useState("Copy Wallet Address");

	const handleCopyToClipboard = async (e) => {
		e.preventDefault();
		if ("clipboard" in navigator) {
			await navigator.clipboard.writeText(copyValue);
			setcopyMessage("Copied");
		} else {
			document.execCommand("copy", true, copyValue);
			setcopyMessage("Copied");
		}
	};
	const communityLinks = [
		{
			name: "Discord",
			image: images.discord,
			link: "https://discord.com/invite/8kQknUCFHs",
		},
		{
			name: "Twitter",
			image: images.twitter,
			link: "https://twitter.com/NitroNetworkNFT ",
		},
		{
			name: "Linkedin",
			image: images.linkedin,
			link: "https://www.linkedin.com/company/nitronetwork/",
		},
		{
			name: "Facebook",
			image: images.facebook,
			link: "https://www.facebook.com/NitroNetworkHQ/",
		},
		{
			name: "Medium",
			image: images.medium,
			link: "https://nitronetwork.medium.com/",
		},
	];
	const tableHeads = [
		"Sl No.",
		"Mint",
		"Date",
		"Price",
		"#No of NFT",
		"Comic Releases",
	];
	// const tableData = [
	// 	{
	// 		sno: 1,
	// 		mint: "Whitelist",
	// 		date: "9 Mar",
	// 		price: "0.05 ETH",
	// 		noOfNFt: "800 Whitelist",
	// 		comicRelease: "-Release Backstory",
	// 	},
	// 	{
	// 		sno: 2,
	// 		mint: "Mint 1 on Opensea",
	// 		date: "13 Mar",
	// 		price: "0.08 ETH",
	// 		noOfNFt: "2000",
	// 		comicRelease: "-Episode 1-9 ",
	// 	},
	// 	{
	// 		sno: 3,
	// 		mint: "Mint 2 on Opensea",
	// 		date: "TBD",
	// 		price: "Higher than Mint 1 (TBD",
	// 		noOfNFt: "TBD",
	// 		comicRelease: "TBD",
	// 	},
	// 	{
	// 		sno: 4,
	// 		mint: "Mint 3",
	// 		date: "TBD",
	// 		price: "Higher than Mint 2 (TBD",
	// 		noOfNFt: "TBD",
	// 		comicRelease: "TBD",
	// 	},
	// ];

	const tableHeadsBenefit = ["Category", "Percentage", "Allocation"];

	const tableDataBenefit = [
		{
			id: 1,
			category: "NFT Staking",
			percentage: "50%",
			allocation: "217,300,000",
		},
		{
			id: 2,
			category: "Community Building",
			percentage: "20%",
			allocation: "86,920,000",
		},
		{
			id: 3,
			category: "Airdrops",
			percentage: "10%",
			allocation: "43,460,000",
		},
		{
			id: 4,
			category: "Partnerships / Collaboration",
			percentage: "20%",
			allocation: "86,920,000",
		},
	];

	// let futureDate = new Date("February 10, 2023 11:30:00");
	// // let futureDate = new Date("2023-02-10T11:30:00");
	// const renderer = (props) => {
	// 	const { formatted, completed } = props;
	// 	const { days, hours, minutes, seconds } = formatted;

	// 	if (completed) {
	// 		// Render a complete state
	// 		return <h1 className="text-center">All Set!</h1>;
	// 	} else {
	// 		// Render a countdown
	// 		return (
	// 			<>
	// 				<div className="timer">
	// 					<div>
	// 						<div className="days">
	// 							<div className="days__one">{days[0]}</div>
	// 							<div className="days__two">{days[1]}</div>
	// 						</div>
	// 						<p>Days</p>
	// 					</div>
	// 					<h2 className="colon">:</h2>
	// 					<div>
	// 						<div className="hours">
	// 							<div className="hours__one">{hours[0]}</div>
	// 							<div className="hours__two">{hours[1]}</div>
	// 						</div>
	// 						<p>Hours</p>
	// 					</div>
	// 					<h2 className="colon">:</h2>

	// 					<div>
	// 						<div className="minutes">
	// 							<div className="minutes__one">{minutes[0]}</div>
	// 							<div className="minutes__two">{minutes[0]}</div>
	// 						</div>
	// 						<p>Minutes</p>
	// 					</div>
	// 				</div>
	// 			</>
	// 		);
	// 	}
	// };

	useEffect(() => {
		if (copyMessage === "Copied") {
			setTimeout(() => {
				setcopyMessage("Copy Wallet Address");
			}, 5000);
		}
		setcopyValue("0x691f0d81190085526EA1b7c631B5a9028aeaEcF7");
	}, [copyMessage, copyValue]);
	return (
		<div>
			{/* {console.log(futureDate)} */}

			<Header />
			{openTerms && <Terms setOpenTerms={setOpenTerms} />}

			<div className="head-section">
				<div className="head-section__video">
					<video autoPlay muted loop>
						<source src={images.video} type="video/mp4" />
						<source src={images.video} type="video/ogg" />
						Your browser does not support the video tag.
					</video>
				</div>
				<div className="head-section__text">
					<h3>
						Unleashing the capabilities of Nitro Bot NFTs in the IoT landscape
					</h3>

					{/* <a href="#whitelist" className="btn btn-pink">
						Whitelist
					</a> */}
					<a
						href="https://opensea.io/collection/nitrobotarmy/drop"
						target="_blank"
						rel="noreferrer"
						className="btn btn-pink"
					>
						Minting Now
					</a>
				</div>
			</div>
			<a
				href="https://opensea.io/collection/nitrobotarmy"
				target="_blank"
				rel="noreferrer"
				className="mint-banner"
			>
				<img src={images.mintBanner} alt="Mint Banner" />
			</a>
			{/* Our Mission */}
			<div className="our-mission pos">
				<div className="hl-icon">
					<img src={images.asset8} alt="Asset" />
				</div>
				<h1 className="heading-primary text-center">OUR MISSION</h1>
				<div className="container">
					<div className="our-mission__grid ">
						<div className="our-mission__text">
							<p>
								We are a team with a mission to bring the power of IoT to the
								masses.
							</p>
							<p>
								IoT has the potential to enhance every aspect of human life, yet
								it remains largely unexplored. Now is the time to awaken people
								to the possibilities of IoT and to use it for the benefit of
								individuals and the planet. Through the use of NFTs, we aim to
								create awareness and understanding of IoT, and to inspire people
								to harness its power for good.
							</p>

							<p>
								Join us on our journey to unlock the full potential of IoT and
								create a better future for all.
							</p>
						</div>

						<div className="our-mission__image">
							<img src={images.ourMission} alt="our mission" />
						</div>
					</div>

					<div className="icon-rt">
						<img src={images.asset9} alt="Asset" />
					</div>
				</div>
			</div>

			{/* bot-utility */}
			<div className="bot-utility pos">
				<div className="hl-icon">
					<img src={images.asset6} alt="Asset" />
				</div>
				<h1 className="heading-primary text-center">NITRO BOT UTILITY</h1>
				<div className="container">
					<div className="bot-utility__image">
						<picture>
							<source media="(min-width:650px)" srcSet={images.nftBotUtility} />
							<source
								media="(min-width:465px)"
								srcSet={images.nftBotUtilityMobile}
							/>
							<img src={images.nftBotUtilityMobile} alt="Flowers" />
						</picture>
						{/* <img src={images.nftBotUtility} alt="our mission" /> */}
					</div>
					<div className="icon-rt">
						<img src={images.asset11} alt="Asset" />
					</div>
				</div>
			</div>

			{/* Whitelist */}
			<div className="whitelist pos" id="whitelist">
				<h1 className="heading-primary text-center">
					<img src={images.whitelist} alt="Whitelist" />
				</h1>
				<div className="container">
					<div className="whitelist__box">
						<img
							src={images.whitelistMarquee}
							className="grid1"
							alt="Whitelist"
						/>

						<div className="whitelist__text-side">
							<p>
								Get ahead of the game by joining the{" "}
								<strong>Nitro Bot NFT Whitelist</strong>. Get early access to
								our coveted digital assets at <strong>0.05 ETH</strong>.
							</p>
							<p>
								Don't miss the chance to be part of the Nitro Bot NFT
								revolution. There are only{" "}
								<strong>800 Whitelist (WL) Spots</strong> available on the
								Whitelist.
							</p>

							<h2>Requirement for Qualifications:</h2>
							<div className="steps">
								<div className="step">
									<p>Step 1:</p>
									<div>
										<p>
											Perform the set of simple tasks defined in the following
											link (Mandatory)
										</p>
										<button
											disabled
											// href="https://gleam.io/gPGCZ/nitro-network-nft-whitelist"
											// target="_blank"
											// rel="noreferrer"
											className="btn btn-white"
										>
											Ended
										</button>
									</div>
								</div>
								<div className="step">
									<p>Step 2:</p>
									<div>
										<p>Send 0.01 ETH to the following address (Optional)</p>
										<div className="input">
											<form className="">
												<input
													className=""
													type="text"
													name="wallet-address"
													id="wallet-address"
													// defaultValue={copyValue}
													value={copyValue}
													disabled
												/>
												<button
													className=""
													onClick={handleCopyToClipboard}
													type="submit"
												>
													{copyMessage}
												</button>
											</form>
										</div>

										<p className="bold wallet-text">
											please confirm the address when you paste the same
										</p>
									</div>
								</div>
								{/* <div className="">
									<img src={images.walletAddress} alt="NFT" />
								</div> */}

								<div className="step">
									<p>Step 3:</p>
									<div>
										<p>
											Enter the Transaction Hash <br /> (of the task performed
											in step 2) <br /> in the task assigned in step 1
											(Optional)
										</p>
									</div>
								</div>
							</div>

							<div className="thats-it">
								<h4>That’s it!</h4>
								<p>
									Have questions related to whitelisting?{" "}
									<Link to="/faq" className="text-underline text-white">
										{" "}
										Check FAQ
									</Link>
								</p>
							</div>
						</div>
						<div className="whitelist__image-side">
							<img src={images.whitelistNFT} alt="NFT" />

							<table>
								<tbody>
									<tr>
										<td>Time</td>
										<td>10 Feb- 6 Mar (Updated)</td>
									</tr>
									<tr>
										<td>Whitelist Spot (WL)</td>
										<td>800</td>
									</tr>
									<tr>
										<td>Whitelist Price</td>
										<td>0.05 ETH</td>
									</tr>
									<tr>
										<td>Status</td>
										<td>Active</td>
									</tr>
								</tbody>
							</table>
							<p
								onClick={() => setOpenTerms(true)}
								className="text-underline mb-sm"
							>
								Terms & Conditions*
							</p>
						</div>

						{/* <div className="icon-lb">
                <img src={images.asset14} alt="ASset" />
              </div> */}
						{/* <div className="icon-rb">
							<img src={images.asset17} alt="ASset" />
						</div> */}
					</div>
				</div>
			</div>

			{/* Our Story */}
			<div className="our-story" id="story">
				<h1 className="heading-primary text-center">Story</h1>
				<div className="container pos">
					<div className="our-story__grid ">
						<div className="our-story__text">
							<p>
								In a distant realm of higher dimensions, there are omniscient
								higher-dimensional beings living in a realm that is unknown and
								unperceivable by other forces in the multiverse. Each variation
								of these beings contributes to the sustenance of the realm,
								defining purpose and function to its foundation. One type of
								being, the Larks, are sun-like beings that overlook the core of
								the realm and offer protection and anti-perception cloaks.
							</p>
						</div>

						<div className="our-story__image pos">
							<img src={images.ourStory} alt="our story" />
							{/* <div className="icon-lb">
								<img src={images.asset19} alt="ASset" />
							</div> */}
						</div>
					</div>
					<div className="icon-lb">
						<img src={images.asset3} alt="ASset" />
					</div>
					<div className="icon-rt">
						<img src={images.asset21} alt="ASset" />
					</div>
				</div>
			</div>
			{/* Our Story 2 */}
			<div className="our-story">
				<div className="container pos">
					<div className="our-story__grid ">
						<div className="our-story__image">
							<img src={images.ourStory2} alt="our story" />
						</div>
						<div className="our-story__text">
							<p>
								However, a dark entity enters the realm, tearing up the fabric
								of space-time and causing chaos and destruction. While the Larks
								are able to transform their structure and offer resistance, the
								other higher-dimensional beings are defenseless. One particular
								Lark is known for its creative and out-of-the-realm approach and
								is brave enough to do what is needed in times of chaos. This
								Lark, in an effort to learn more about the dark entity, infects
								itself with the parasitic tentacle of the dark entity and learns
								that it originated from a lower dimension and is consuming
								energy to fuel its war on higher dimensional existence.
							</p>
						</div>
					</div>

					<div className="icon-rb">
						<img src={images.asset7} alt="ASset" />
					</div>
				</div>
			</div>
			{/* Our Story 3*/}
			<div className="our-story">
				<div className="container pos">
					<div className="our-story__grid ">
						<div className="our-story__text">
							<p>
								The Lark then discovers a tunnel of the dark entity's energy
								path, traversing through several worlds of the multiverse, and
								ultimately decides to battle the dark entity in a "fair zone" of
								the middle realm where the odds of winning are even. The ‘fair
								zone” is Earth where human lives a chaotic life and in order to
								win the lark has to establish harmony in the ecosystem. In order
								to fulfil his mission he disguises himself as Dr Nitro and
								creates Nitro Bots army to win the battle again the dark
								entity. 
							</p>
						</div>

						<div className="our-story__image">
							<img src={images.ourStory3} alt="our story" />
						</div>
					</div>
					<div className="icon-lt">
						<img src={images.asset4} alt="ASset" />
					</div>
				</div>
			</div>

			<div className="story-explore">
				<p>
					The Nitro Bot and Dr Nitro have to win this battle. Let’s fight
					together with them!
				</p>

				<div className=" btn btn-pink">Chapters Coming Soon</div>
			</div>
			{/* NFT SUPPLY */}
			<div className="nft-supply">
				<h1 className="heading-primary-2 text-center">NFt supply</h1>
				<div className="container pos">
					<div className="nft-supply__boxes ">
						<div className="nft-supply__box">
							<img src={images.nftSupply1} alt="NFT supply" />
						</div>
						<div className="nft-supply__box">
							<img src={images.nftSupply2} alt="NFT supply" />
						</div>
						<div className="nft-supply__box">
							<img src={images.nftSupply3} alt="NFT Supply" />
						</div>
					</div>
					<div className="nft-supply__count">
						<p>Total supply:</p>
						<h2 className="bold-text">7,500</h2>
						{/* <p>Mint Price:</p>
								<h2 className="bold-text">0.08 ETH</h2>
								<p>Launch Date:</p>
								<h2 className="bold-text">28 FEB 2023</h2> */}
					</div>
				</div>
				<div className="bordered-box">
					<a
						href="https://opensea.io/collection/nitrobotarmy/drop"
						target="_blank"
						rel="noreferrer"
						className="btn btn-opensea"
					>
						<img src={images.opensea} alt="Opensea" />
					</a>
				</div>
			</div>

			{/* Benefit-rewards */}
			<div className="benefit-rewards pos">
				<h1 className="heading-primary-2 text-center">Benefits & Rewards</h1>
				<div className="container">
					<div className="benefit-rewards__grid">
						<div className="benefit-rewards__table">
							<div className="dflex">
								<p>Total Pool of Nitro NFT Reward</p>
								<h2>434,600,000</h2>
							</div>
							<table className="">
								<thead>
									<tr>
										{tableHeadsBenefit.map((data, i) => {
											return (
												<th key={i} scope="col" className="right">
													{data}
												</th>
											);
										})}
									</tr>
								</thead>
								<tbody>
									{tableDataBenefit.map((data, i) => {
										return (
											<tr key={i}>
												<td className="text-left" data-label={tableHeads[0]}>
													{data.category}
												</td>
												<td
													className=" right overflow-text"
													data-label={tableHeads[1]}
												>
													<span className="trx-id">{data.percentage}</span>
												</td>
												<td
													className="right max-time"
													data-label={tableHeads[2]}
												>
													<span className="time-font">{data.allocation}</span>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>

							<p className="text-right">
								Note: The reward pool is subject to change. It will follow
								Nitro’s standard token model.
								<a
									href="https://nitro.network/ncash "
									target="_blank"
									rel="noreferrer"
								>
									{" "}
									Read more here
								</a>
							</p>
						</div>
						<div className="benefit-rewards__graph">
							<img src={images.rewards} alt="Rewards" />
						</div>
					</div>
				</div>
			</div>

			{/* Mint Roadmap */}
			{/* <div className="mint-roadmap">
				<h1 className="heading-primary-2 text-center">mint roadmap</h1>
				<div className="container pos">
					<div className="mint-roadmap__table">
						

						<table className="">
							<thead>
								<tr>
									{tableHeads.map((data, i) => {
										return (
											<th key={i} scope="col" className="right">
												{data}
											</th>
										);
									})}
								</tr>
							</thead>
							<tbody>
								{tableData.map((data, i) => {
									return (
										<tr key={i}>
											<td data-label={tableHeads[0]}>
												<span className="address-text-table">{data.sno}</span>
											</td>
											<td className="right" data-label={tableHeads[1]}>
												{data.mint}
											</td>
											<td
												className=" right overflow-text"
												data-label={tableHeads[2]}
											>
												<span className="trx-id">{data.date}</span>
											</td>
											<td className="right max-time" data-label={tableHeads[3]}>
												<span className="time-font">{data.price}</span>
											</td>
											<td className="right" data-label={tableHeads[4]}>
												{data.noOfNFt}
											</td>
											<td className="right" data-label={tableHeads[5]}>
												{data.comicRelease}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
						<p className="text-right">
							Note: The reward pool is subject to change. It will follow Nitro’s
							standard token model.
							<a
								href="https://nitro.network/ncash "
								target="_blank"
								rel="noreferrer"
							>
								{" "}
								Read more here
							</a>
						</p>
					</div>
				</div>
			</div> */}

			{/* NFT Roadmap */}
			<div className="nft-roadmap">
				<h1 className="heading-primary text-center">NFT ROADMAP</h1>
				<div className="container pos">
					<div className="nft-roadmap__image">
						<img src={images.roadmap} alt="our mission" />
					</div>
				</div>
			</div>

			{/* PHASE SOON */}
			<div className="phases-roadmap">
				<div className="timeline">
					<div className="container left">
						<h1 className="h1-style">Phase 1</h1>
						<div className="content border-top">
							<ul className="list-style">
								<li>
									<img src={images.circle} alt="icon" className="img-width" />
									<span className="li-pad">Launch website Version1</span>
								</li>
								<li>
									<img src={images.circle} alt="" className="img-width" />
									<span className="li-pad">Release Backstory</span>
								</li>
								<li>
									<img src={images.circle} alt="" className="img-width" />
									<span className="li-pad">Whitelisting</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Release Season 1 Episode</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">
										Execute First Nitro NFT Airdrop- NDROP1
									</span>
								</li>
								<li>
									<img src={images.circle} alt="" className="img-width" />{" "}
									<span className="li-pad">Start Minting on Opensea</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />{" "}
									<span className="li-pad">Launch NFT staking and Reward</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad"> Reveal the Rarity</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="container right">
						<h1 className="h1-style contant-right">Phase 2</h1>
						<div className="content border-top">
							<ul className="list-style">
								<li>
									<img
										src={images.circleOpen}
										alt="icon"
										className="img-width"
									/>
									<span className="li-pad">NFT promotion kicks off</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Launch QUEST #1</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Launch Community Space</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Start Community Campaign</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">
										Do Second Nitro NFT Airdrop- NDROP2
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="container left-3">
						<h1 className="h1-style">Phase 3</h1>
						<div className="content border-top">
							<ul className="list-style">
								<li>
									<img
										src={images.circleOpen}
										alt="icon"
										className="img-width"
									/>
									<span className="li-pad">Launch SWAG+FAME</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Create IP for Nitro NFT Comic</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">
										Create more interactive content for the comic
									</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Launch QUEST #2</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="container right-4">
						<h1 className="h1-style contant-right">Phase 4</h1>
						<div className="content border-top">
							<ul className="list-style">
								<li>
									<img
										src={images.circleOpen}
										alt="icon"
										className="img-width"
									/>
									<span className="li-pad">
										Launch NFT collaboration Program
									</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Website REVAMP- Version 2</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">NEW NFT DROP</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Release Season 2 Episodes</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />
									<span className="li-pad">Launch Nitro Merch Shop</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />{" "}
									<span className="li-pad">
										Do Third Nitro NFT Airdrop- NDROP 3
									</span>
								</li>
								<li>
									<img src={images.circleOpen} alt="" className="img-width" />{" "}
									<span className="li-pad">
										Integrate NFT into metaverses and NFT
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="content phase-5">
					<h1 className="h1-style-phase5">Phase 5</h1>
					<ul className="list-style">
						<li>
							<img src={images.circleOpen} alt="icon" className="img-width" />
							<span className="li-pad">NFT promotion kicks off</span>
						</li>
						<li>
							<img src={images.circleOpen} alt="" className="img-width" />
							<span className="li-pad">Launch QUEST #1</span>
						</li>
						<li>
							<img src={images.circleOpen} alt="" className="img-width" />
							<span className="li-pad">Launch Community Space</span>
						</li>
						<li>
							<img src={images.circleOpen} alt="" className="img-width" />
							<span className="li-pad">Start Community Campaign</span>
						</li>
						<li>
							<img src={images.circleOpen} alt="" className="img-width" />
							<span className="li-pad">
								Do Fourth Nitro NFT Airdrop- NDROP 4
							</span>
						</li>
					</ul>
				</div>
			</div>

			<div className="join-community">
				<h1 className="heading-primary text-center">Community</h1>
				<h2 className="head-second">Join community & earn rewards</h2>

				{/* Community ICON */}
				<div className="community-icons">
					{communityLinks.map((link) => {
						return (
							<a
								key={link.name}
								href={link.link}
								target="_blank"
								rel="noopener noreferrer"
								className="gateway-icon"
							>
								<img src={link.image} alt={link.name} />
								<p>{link.name}</p>
							</a>
						);
					})}
				</div>
			</div>

			{/* Blogs */}
			<div className="blogs">
				<h1 className="heading-primary text-center">Blogs</h1>
				<div className="container">
					<div className="blogs__boxes">
						<a
							href="https://medium.com/@nitronetwork/nitro-bot-launch-unlocking-a-new-era-of-utility-1ea333af2c8a"
							target="_blank"
							rel="noreferrer"
							className="blogs__box"
						>
							<img src={images.blog1} alt="Blog" />
							<div>
								<p>Unlocking a New Era of Utility</p>

								<p>~ 5 Min read</p>
							</div>
						</a>
						<a
							href="https://medium.com/@nitronetwork/mint-nitro-bot-army-on-opensea-925d5e61d1c"
							target="_blank"
							rel="noreferrer"
							className="blogs__box"
						>
							<img src={images.blog2} alt="Blog" />
							<div>
								<p>Mint Nitro Bot Army on Opensea</p>
								<p>~ 5 Min read</p>
							</div>
						</a>
					</div>
				</div>
			</div>
			{/* <div className="footer">
				<p>Copyright © 2023 Nitro Network. All rights reserved.</p>
			</div> */}
		</div>
	);
};

export default Home;
